<!--Banner-->
<div class="games-banner" [ngClass]="{ 'show-footer': showFooter }">
  <div class="text-center pt-2">
    <img *ngIf="isPollsPage" class="games-banner-img" src="{{ bannerImage.polls }}" />
    <img *ngIf="isTriviaPage" class="games-banner-img" src="{{ bannerImage.trivia }}" />
    <img *ngIf="isPredictorPage" class="games-banner-img" src="{{ bannerImage.predictor }}" />

    <ng-container *ngIf="!isPollsPage">
      <div class="container navbar-container">
        <nav class="nav leaderboard-nav">
          <div class="nav-item">
            <a
              *ngIf="isTriviaPage"
              [routerLink]="'/games/trivia'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.play' | translate }}

              <div class="active-border"></div>
            </a>

            <a
              *ngIf="isPredictorPage"
              [routerLink]="'/games/predictor'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.play' | translate }}

              <div class="active-border"></div>
            </a>
          </div>

          <div class="nav-item">
            <a
              *ngIf="isTriviaPage"
              [routerLink]="'/games/trivia/leaderboard'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.leaderboard' | translate }}

              <div class="active-border"></div>
            </a>

            <a
              *ngIf="isPredictorPage"
              [routerLink]="'/games/predictor/leaderboard'"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ 'games.nav.leaderboard' | translate }}

              <div class="active-border"></div>
            </a>
          </div>
        </nav>
      </div>
    </ng-container>
  </div>
</div>
